import {UI} from "../../../../../stem-core/src/ui/UIBase";
import {Messages} from "../../../../Messages";
import {styleRule, StyleSheet} from "../../../../../stem-core/src/ui/Style";
import {CreditCardIcon} from "../../../../ui/CreditCardIcon";
import {DonationStore} from "../../../../../client/state/DonationStore";
import {SubscriptionStore} from "../../../../../client/state/SubscriptionStore";
import {DEFAULT_DATE_FORMAT} from "../../../../Constants";
import {PaymentStore} from "../../../../../client/state/PaymentStore";
import {EndpointPaginator} from "../../../../../client/state/EndpointPaginator";
import {UIPaginationManager} from "../../../../ui/BaseCard";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";


class InlineUserDashboardPaymentsTableStyle extends StyleSheet {
    @styleRule
    listItem = {
        padding: "12px 18px",
        borderBottom: "1px solid #E5E5E5",
        display: "flex",
    };

    @styleRule
    header = {
        display: "flex",
        padding: "14px 18px",
        background: this.themeProps.MERCHANT_FRAME_HEADER_BACKGROUND,
        color: this.themeProps.MERCHANT_FRAME_CLOSE_BUTTON_COLOR,
    };

    @styleRule
    cardIcon = {
        marginRight: 12,
        display: "inline-block",
    };

    @styleRule
    paymentDetails = {
        display: "inline-block",
        ">:first-child": {
            fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        },
        ">:last-child": {
            fontSize: this.themeProps.MERCHANT_FONT_SIZE_SMALL,
        }
    }
}

@registerStyle(InlineUserDashboardPaymentsTableStyle)
export class InlineUserDashboardPaymentsTable extends UI.Element {
    paginator = new EndpointPaginator(
        PaymentStore,
        PaymentStore.API_LIST_ENDPOINT,
        {resourceTypes: [this.options.resourceType]},
        {resourceType: this.options.resourceType},
    );
    paginationHandler = new UIPaginationManager(this);
    columns = [{
        headerMessage: Messages.description,
        elementBuilder: payment => this.renderPaymentDetails(payment),
        textAlign: "left",
        justifyContent: "",
        flex: 0.5,
    }, {
        headerMessage: Messages.amount,
        elementBuilder: payment => this.renderPaymentAmount(payment),
        textAlign: "left",
        justifyContent: "",
        flex: 0.25,
    }, {
        headerMessage: Messages.date,
        elementBuilder: payment => this.renderPaymentDate(payment),
        textAlign: "center",
        justifyContent: "space-around",
        flex: 0.25,
    }];

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            resourceType: "",
        };
    }

    renderPaymentDetails(payment) {
        const {styleSheet} = this;
        const paymentMethod = payment?.getPaymentMethod();
        const cardDescription = paymentMethod ?
            paymentMethod.getBrand() + " " + paymentMethod.getMaskedDigits() : Messages.walletFunds;
        let paymentDescription = "";
        if (payment.resourceType === "subscription") {
            paymentDescription = SubscriptionStore.get(payment.resourceId).coverage.name;
        } else if (payment.resourceType === "donation") {
            paymentDescription = DonationStore.get(payment.resourceId).isRecurring() ? Messages.recurring : Messages.oneTime;
        }

        return [
            <CreditCardIcon className={styleSheet.cardIcon} brand={paymentMethod?.getBrand()} size={16}/>,
            <div className={styleSheet.paymentDetails}>
                <b>{paymentDescription}</b>
                <div>{cardDescription}</div>
            </div>
        ];
    }

    renderPaymentAmount(payment) {
        return <b>{payment.getAmount()}</b>;
    }

    renderPaymentDate(payment) {
        return payment.createdAt.format(DEFAULT_DATE_FORMAT);
    }

    getPayments() {
        return this.paginator.all().filter(payment => payment.merchantId === iFrameMerchantService.getMerchant().id)
            .sort((a, b) => b.createdAt - a.createdAt);
    }

    render() {
        const {styleSheet} = this;

        if (!this.getPayments().length) {
            return Messages.emptyPayments;
        }

        return [
            <div className={styleSheet.header}>
                {this.columns.map(({headerMessage, textAlign, flex}) =>
                    <div style={{textAlign, flex, textTransform: "capitalize"}}>{headerMessage}</div>)}
            </div>,
            this.getPayments().map(payment =>
                <div className={styleSheet.listItem}>
                    {this.columns.map(({elementBuilder, textAlign, flex, justifyContent}) =>
                        <div style={{textAlign, flex, justifyContent, display: "flex", alignItems: "center"}}>{elementBuilder(payment)}</div>)}
                </div>
            )
        ];
    }

    onMount() {
        super.onMount();
        this.paginationHandler.attach();
    }
}
